import { serialize } from 'cookie'
const ENCRYPTION_KEY_COOKIE_NAME = 'achieve_dashboard_state_key'

export const getCookiesObject = (cookies) => {
  const cookieObject = cookies
    ? cookies.split(';').reduce((prev, current) => {
        const [name, value] = current.trim().split('=')
        prev[name] = value
        return prev
      }, {})
    : {}

  return cookieObject
}

/**
 * Sets __Host- prefix for extra security when in HTTPS env.
 * https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie#cookie_prefixes
 * @param {String} name Name of the cookie
 * @returns {String} Name of the cookie
 */
export const getSecureCookieName = (name) => {
  return `${process.env.NODE_ENV === 'production' ? '__Host-' : ''}${name}`
}

/**
 * Returns the representation of a HTTP cookie to be created.
 * Requires setHeader() to be called. See example.
 * Sets __Host- prefix for extra security when in HTTPS env.
 * @param {String} name Name of the cookie
 * @param {String} value Contents of the cookie
 * @param {Object} {serializeArgs} CookieSerializeOptions
 * @returns {String} The cookie
 * @example context.res.setHeader("Set-Cookie", createCookie(...));
 */
export const createCookie = (name, value, serializeArgs = {}) => {
  return serialize(getSecureCookieName(name), String(value), {
    ...serializeArgs,
    httpOnly: true,
    secure: process.env.NODE_ENV === 'production',
    // Uses Lax so that the cookie can be used even when there is a Referrer
    sameSite: 'lax',
    path: '/',
  })
}

export const setNewOTECookie = (encryptionKey) => {
  // Create and Set HttpOnly Cookie on page load.
  // Yes, the process will break if the user does not submit the form before maxAge, which 3600 seconds is an hour.
  const newEncryptionKeyCookie = createCookie(ENCRYPTION_KEY_COOKIE_NAME, encryptionKey, {
    maxAge: 3600,
  })

  return newEncryptionKeyCookie
}
